import React, { Component } from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';

import { Counter } from 'components';
import { Icon } from 'elements';
import { classnames, classname, raw } from 'utils';
import { GetCategory, GetCompany } from 'query';

import './Category.css';

class Category extends Component {
  cl = classname('category');

  render() {
    const { className, title, id, uri, section, companies } = this.props;

    const classes = classnames(className, this.cl());

    const groups = {
      ...this.props.groups,
      all: {
        title: 'Все компании',
        short_title: 'Все'
      }
    };

    console.log("groups");
    console.log(Object.keys(this.props.groups).length);
    if(Object.keys(this.props.groups).length == 1) {
      delete groups['all'];
    }

    const activeGroup = Object.keys(groups).find(item => {
      return section === item;
    });

    const groupDescription = activeGroup ? groups[activeGroup].description : null;

    const fullTitle =
      title + (section !== 'all' ? '. ' + groups[section].title : '') + ' – AdIndex. Technology Map 2020';

    return (
      <div className={classes}>
        <Helmet>
          <title>{fullTitle}</title>
          <meta property="og:title" content={fullTitle} />
        </Helmet>
        <div className={this.cl('header')}>
          <ul className={this.cl('types-list')}>
            {Object.keys(groups).map(key => {
              const value = groups[key];

              const current = key === section;
              const to = uri + key + '/';

              const Tag = current ? 'div' : Link;

              return (
                <li key={key} className={this.cl('types-item', { current })}>
                  {!value.short_title ? (
                    <Tag to={to} className={this.cl('types-button')} {...raw(value.title)} />
                  ) : (
                    <Tag to={to} className={this.cl('types-button')}>
                      <span className={'hide_mobile'} {...raw(value.title)} />
                      <span className={'hide_not_mobile'} {...raw(value.short_title)} />
                    </Tag>
                  )}
                </li>
              );
            })}
          </ul>
          {groupDescription && <div className={this.cl('description')}>{groupDescription}</div>}
        </div>
        <div className={this.cl('data')}>
          <ul className={this.cl('list')}>
            {companies
              .filter(item => {
                if (item.rating[id]) {
                  if (section === 'all') {
                    return Object.values(item.rating[id]).some(item => item !== null);
                  } else {
                    return item.rating[id] && item.rating[id][section] !== null;
                  }
                }

                return false;
              })
              .sort((a, b) => {
                if (section === 'all') {
                  if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
                  if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
                  return 0;
                } else {
                  if(b.rating[id][section] == a.rating[id][section]) {
                    if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
                    if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
                    return 0;
                  } else {
                    return b.rating[id][section] - a.rating[id][section];
                  }
                }
              })
              .map(item => {
                const type = section === 'all' ? 'simple' : 'rating';
                const value = item.rating[id][section];
                let done = false;
                return (
                  <>
                  {console.log(done)}
                  <li className={[this.cl('item'), value ? '' : `${this.cl('item')}-star`].join(' ')} key={item.id}>
                    <Link to={item.uri} className={this.cl('company', { [type]: true })}>
                      {section !== 'all' && <Counter align={value ? 'center' : 'left'}>{value}</Counter>}
                      <div className={this.cl('name')}>
                        <div className={this.cl('link')}>{item.title}</div>
                      </div>
                    </Link>
                  </li>
                  </>
                );
              })}
          </ul>
        </div>
      </div>
    );
  }
}

export default ({ id, section }) => (
  <GetCategory options={{ id }}>
    {data => <GetCompany>{companies => <Category section={section} companies={companies} {...data} />}</GetCompany>}
  </GetCategory>
);
